<template>
    <div class="login-card">
      <div class="card card-login">
        <div class="card-header">
          <h3 class="header text-center">Iniciar Sesión</h3>
        </div>
        <div class="card-body">
          <div v-if="error" class="alert alert-danger">
            {{ error }}
          </div>
          
          <form @submit.prevent="handleLogin">
            <div class="form-group">
              <label>Usuario</label>
              <input 
                type="text" 
                class="form-control" 
                placeholder="Usuario" 
                v-model="form.username"
                :class="{ 'is-invalid': validationErrors.username }"
              >
              <div v-if="validationErrors.username" class="invalid-feedback">
                {{ validationErrors.username[0] }}
              </div>
            </div>
            
            <div class="form-group">
              <label>Contraseña</label>
              <input 
                type="password" 
                class="form-control" 
                placeholder="Contraseña" 
                v-model="form.password"
                :class="{ 'is-invalid': validationErrors.password }"
              >
              <div v-if="validationErrors.password" class="invalid-feedback">
                {{ validationErrors.password[0] }}
              </div>
            </div>
            
            <div class="form-group">
              <label>Código de seguridad</label>
              <div class="captcha-container">
                <div v-html="captchaImage" class="captcha-image"></div>
                <button 
                  type="button" 
                  class="btn btn-sm btn-outline-secondary" 
                  @click="refreshCaptcha"
                >
                  <i class="fas fa-refresh"></i>
                </button>
              </div>
              <input 
                type="text" 
                class="form-control mt-2" 
                placeholder="Ingrese el código de seguridad" 
                v-model="form.captcha"
                :class="{ 'is-invalid': validationErrors.captcha }"
              >
              <div v-if="validationErrors.captcha" class="invalid-feedback">
                {{ validationErrors.captcha[0] }}
              </div>
            </div>
            
            <div class="text-center">
              <button type="submit" class="btn btn-primary btn-round btn-lg btn-block" :disabled="loading">
                <span v-if="loading">Iniciando sesión...</span>
                <span v-else>Iniciar Sesión</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useAuthStore } from '../../stores/authStore';
import axios from 'axios';

export default {
  setup() {
    const authStore = useAuthStore();
    const form = ref({
      username: '',
      password: '',
      captcha: ''
    });
    const captchaImage = ref('');
    const loading = ref(false);
    const error = ref('');
    const validationErrors = ref({});

    const refreshCaptcha = async () => {
      try {
        const response = await axios.get('/refresh-captcha');
        captchaImage.value = response.data.captcha;
      } catch (err) {
        console.error('Error al cargar captcha:', err);
      }
    };

    const handleLogin = async () => {
      loading.value = true;
      error.value = '';
      validationErrors.value = {};

      try {
        await authStore.login(form.value);
      } catch (err) {
        if (err.response?.status === 422) {
          validationErrors.value = err.response.data.errors;
        } else {
          error.value = err.response?.data?.message || 'Error al iniciar sesión. Intente nuevamente.';
        }
        // Refrescar captcha después de un intento fallido
        refreshCaptcha();
      } finally {
        loading.value = false;
        form.value.captcha = '';
      }
    };

    onMounted(() => {
      refreshCaptcha();
    });

    return {
      form,
      captchaImage,
      loading,
      error,
      validationErrors,
      refreshCaptcha,
      handleLogin
    };
  }
};
</script>

<style scoped>
.login-card {
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
}
.captcha-container {
  display: flex;
  align-items: center;
  gap: 10px;
}
.captcha-image {
  flex-grow: 1;
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 5px;
}
</style>